import { atom } from "recoil";

export const routeState = atom<{
  currentRouteName: string;
  currentSidebarHref: string;
}>({
  key: "routeState",
  default: {
    currentRouteName: "",
    currentSidebarHref: "",
  },
});
